"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _excluded = ["type", "disabled", "className", "style", "title", "description"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
var CheckboxRadioList = function CheckboxRadioList(props) {
  var type = props.type,
    disabled = props.disabled,
    className = props.className,
    style = props.style,
    title = props.title,
    description = props.description,
    rest = _objectWithoutProperties(props, _excluded);
  var classes = (0, _classnames["default"])("radio-checkbox-list", type, className);
  var children = _react["default"].Children.toArray(props.children);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "checkboxRadioList-component"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: classes,
    style: style
  }, type === "ext-2" && /*#__PURE__*/_react["default"].createElement("div", {
    className: "header-container"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "title"
  }, title), /*#__PURE__*/_react["default"].createElement("div", {
    className: "description"
  }, description)), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("ul", null, children.map(function (child, index) {
    return /*#__PURE__*/_react["default"].createElement("li", {
      key: index,
      className: (0, _classnames["default"])(child.props.checked && 'selected', child.props.disabled && 'disabled')
    }, child);
  })))));
};
CheckboxRadioList.propTypes = {
  type: _propTypes["default"].oneOf(["", "ext-1", "ext-2"]),
  disabled: _propTypes["default"].bool,
  className: _propTypes["default"].string,
  style: _propTypes["default"].object,
  title: _propTypes["default"].string,
  description: _propTypes["default"].string
};
CheckboxRadioList.defaultProps = {
  type: "",
  disabled: false,
  className: "",
  style: {},
  title: "",
  description: ""
};
var _default = exports["default"] = CheckboxRadioList;